var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert-tooltip',{ref:"alertTooltip",attrs:{"heading":_vm.heading,"message":_vm.message,"placement":_vm.placement,"target":_vm.target},on:{"dismiss":_vm.dismissTip}})}
var staticRenderFns = []

export { render, staticRenderFns }